module.exports = __webpack_public_path__ + "static/media/cover.15f17cf0.png";